import React from "react";
import "./WhenYouFeelReady.css";

const WhenYouFeelReady: React.FC = () => {
  const pointers = [
    "Send a message on WhatsApp/ Call: +91 9625998829",
    "We will connect for a brief call",
    "You will fill a short and simple intake form at your comfort",
    "We will then schedule your first session together",
  ];

  return (
    <section id="when-ready" className="when-ready-section">
      <div className="when-ready-container">
        <h2 className="section-heading">When You Feel Ready</h2>
        <div className="session-options">
          <div className="session-option">
            <div className="option-icon">💻</div>
            <h3 className="option-title">Online Sessions</h3>
            <p className="option-description">
              Connect from the comfort of your own space through secure video
              sessions. Online therapy offers flexibility and convenience while
              maintaining the same quality of care and therapeutic connection.
            </p>
          </div>
          <div className="session-option">
            <div className="option-icon">🏢</div>
            <h3 className="option-title">Offline Sessions</h3>
            <p className="option-description">
              In-person sessions available at our location in Lajpat Nagar.
              Experience the warmth of face-to-face connection in a comfortable,
              welcoming environment designed to support your healing journey.
            </p>
            <p className="location">📍 Lajpat Nagar</p>
          </div>
        </div>
        <div className="ready-pointers">
          <h3 className="pointers-heading">Let's Begin Together</h3>
          <div className="pointers-grid">
            {pointers.map((pointer, index) => (
              <div
                key={index}
                className="ready-pointer-item"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="pointer-bullet">{index + 1}</div>
                <p className="pointer-text">{pointer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhenYouFeelReady;
